/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CashbackSource {
    CARD_LINKING_BENEFIT = 'CardLinkingBenefit',
    PARSED_DISPLAY = 'ParsedDisplay',
    ADMIN_OVERRIDE = 'AdminOverride',
    UNAVAILABLE = 'Unavailable',
}
